import { render, staticRenderFns } from "./examSeason2.vue?vue&type=template&id=223dd806&scoped=true&"
import script from "./examSeason2.vue?vue&type=script&lang=js&"
export * from "./examSeason2.vue?vue&type=script&lang=js&"
import style0 from "./examSeason2.vue?vue&type=style&index=0&id=223dd806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223dd806",
  null
  
)

export default component.exports